"use client";
import { useParallax } from "@/hooks/useParallax";
import styles from "./ParallaxBackground.module.scss";

interface ParallaxBackgroundProps {
  children: React.ReactNode;
  speed?: number;
  className?: string;
}

export const ParallaxBackground = ({
  children,
  speed = 0.3,
  className = "",
}: ParallaxBackgroundProps) => {
  const { ref } = useParallax({ speed });
  return (
    <div
      ref={ref}
      className={`${styles["parallax-background"]} ${className}`.trim()}
    >
      {children}
    </div>
  );
};
